import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapApprovalRoundDetail,
  mapApprovalRoundPage,
  type ApprovalActionMutationRaw,
  type ApprovalRoundDetailRaw,
  type ApprovalRoundPageRaw,
} from "../api/adapters";
import type { ApprovalInboxTab } from "../types";

const endpoint = "/approval/rounds";

/** 读取待我审批或我已审批的一页。 */
export async function fetchApprovalRounds(tab: ApprovalInboxTab, page: number, pageSize: number) {
  const response = await httpClient.get<ApiEnvelope<ApprovalRoundPageRaw>>(`${endpoint}/${tab}`, {
    params: { page, page_size: pageSize },
  });
  return mapApprovalRoundPage(requireData(response.data));
}

/** 读取一张单子的业务摘要和每一级的处理记录。 */
export async function fetchApprovalRoundDetail(roundId: string) {
  const response = await httpClient.get<ApiEnvelope<ApprovalRoundDetailRaw>>(`${endpoint}/${encodeURIComponent(roundId)}`);
  return mapApprovalRoundDetail(requireData(response.data));
}

/** 通过页面上看到的当前级；意见可不填。禁止自动重试非幂等写入。 */
export async function approveApprovalRound(roundId: string, stepNo: number, remark: string | null) {
  return act(roundId, "approve", { step_no: stepNo, remark });
}

/** 驳回页面上看到的当前级；意见必填。禁止自动重试非幂等写入。 */
export async function rejectApprovalRound(roundId: string, stepNo: number, remark: string) {
  return act(roundId, "reject", { step_no: stepNo, remark });
}

/** 发出通过或驳回，返回处理后的详情。 */
async function act(roundId: string, action: "approve" | "reject", body: ApprovalActionMutationRaw) {
  const response = await httpClient.post<ApiEnvelope<ApprovalRoundDetailRaw>>(
    `${endpoint}/${encodeURIComponent(roundId)}/${action}`,
    body,
    { "axios-retry": { retries: 0 } },
  );
  return mapApprovalRoundDetail(requireData(response.data));
}

/** 校验统一响应，避免空载荷泄漏成属性读取错误。 */
function requireData<T>(envelope: ApiEnvelope<T>): T {
  if (envelope.code !== "OK" || envelope.data == null) throw new Error("审批接口返回无效数据。");
  return envelope.data;
}
